import { clientApi } from 'shared/api/clientApi'
import { Pagination, Response } from 'shared/models/general'

import { OrdersBeket, OrdersByIdBeket } from './model'

interface PaginationMyTickets extends Pagination {
  is_active?: boolean
}

interface MyOrdersRequest extends Pagination, Response<OrdersBeket[]> {}

export const MyOrdersBeketApi = {
  getListOrders(data: PaginationMyTickets) {
    return clientApi.get<MyOrdersRequest>(`/bus/my-orders/`, {
      params: data,
    })
  },

  getOrderById(id: string) {
    return clientApi.get<Response<OrdersByIdBeket>>(`/bus/my-orders/${id}`)
  },

  getReceipt(id: string) {
    return clientApi.get<Response<string>>(`/bus/get-receipt/${id}`)
  },
}
